export default __webpack_public_path__ + "static/media/inner7.baa56fd4.jpg";